import axios from 'axios';

type loginProps = {
    address: string;
    password: string;
}
export type loginResponse = {
    accountId: number;
    division: number;
    secAccId: number;
    rotaryCd: string;
}

/**
 * ログイン状態か否かを判断するAPIを呼び出す関数
 * @param props 
 * @returns 
 */
export async function getLoginInfo(props: loginProps){
    try{
        const response = await axios.get(process.env.REACT_APP_PATH + `/login/certification`, {
            params: {
                address: props.address,
                password: props.password
            },
            paramsSerializer:{
                indexes: null
            }
        })
        return JSON.parse(JSON.stringify(response.data[0]));
    }catch(err){
    }
}